import Images from '../Utils/images';
import CustomButton from './CustomButton';

interface Props {
  heading?: string;
  title?: string;
  buttonText?: string;
  handleClick?: (event: React.MouseEvent<HTMLButtonElement> | void) => void;

  img?: boolean;
  disabled?: boolean;
  className?: string;
  image?: string;
  showIconButton?: boolean;
  buttonIcon?: string;
  isStoreSearch?: boolean;
}

export default function NoData(props: Props) {
  const {
    heading,
    title,
    buttonText,
    handleClick,
    img = true,
    disabled,
    className,
    image,
    showIconButton = false,
    buttonIcon,
    isStoreSearch,
  } = props;
  // console.log(disabled)
  return (
    <div
      className={`success ${
        isStoreSearch ? 'store-search-nodata' : ''
      } ${className}`}
    >
      {image !== '' && image !== undefined ? (
        <img src={image} alt={heading} />
      ) : (
        <>
          {img && (
            <img
              src={disabled ? Images.NO_RECORD_FOUND : Images.NO_DATA_FOUND}
              alt={heading}
            />
          )}
        </>
      )}
      {heading &&
        (isStoreSearch ? (
          <p className="nodata-message">{heading}</p>
        ) : (
          <h3>{heading}</h3>
        ))}

      {title && <p>{title}</p>}
      {buttonText && (
        <CustomButton
          size="large"
          variant="contained"
          text={buttonText as string}
          showIcon={showIconButton}
          // width="100%"
          onClick={handleClick}
          id="redirect"
          loading={false}
          icon={buttonIcon}
          // onClick={onClick}
          disabled={disabled}
          iconPosition="start"
        />
      )}
    </div>
  );
}
